<template>
  <div class="s-warp" :id="id">
    <input
      type="text"
      class="clearInput"
      :class="tip && required ? 'inputWarn' : ''"
      v-model="label"
      @blur="blurInput"
      @focus="focusInput"
      @input="changeWord"
      :placeholder="setPlaceholder"
    />

    <div v-if="!isInput" class="s-show">
      <el-scrollbar ref="scrollbar">
        <div v-if="isShow">
          <div v-if="status === 0" class="NoData">
            <!-- <img src="../../../../static/img/loading.gif" class="s-loading" /> -->
          </div>
          <div v-if="status === -1" class="NoData">
            <div class="textC" style="line-height: 2">加载地址出现问题</div>
            <div class="textC" style="line-height: 2">请刷新重试</div>
          </div>
          <template v-if="status === 1">
            <div v-show="!selectData.length" class="NoData">No results</div>
            <ul v-show="selectData.length" class="s-ulBox">
              <slot></slot>
            </ul>
          </template>
        </div>
      </el-scrollbar>
    </div>
  </div>
</template>
<script>
import Emitter from "@/utils/emitter";
export default {
  name: "BySelect",
  componentName: "BySelect",

  mixins: [Emitter],

  props: {
    easy: { type: Boolean }, //简单模式  如果是简单模式就不做清除
    selectData: { type: Array },
    id: {
      type: String,
      default: "id" + Date.now().toString(Math.floor(Math.random() * 34) + 2)
    },
    setPlaceholder: { type: String, default: "请输入" },
    valueObj: { type: Object },
    required: { type: Boolean },
    status: { type: Number, default: 1 }, //状态码 如果调取接口可以传值 -1 失败 0 加载中 1 成功
    triggerOnFocus: { type: Boolean, default: true }, //输入再显示建议
    isInput: {
      type: Boolean,
      defualt: false
    }
  },

  model: {
    prop: "valueObj",
    event: "callEvent"
  },

  data() {
    return {
      label: "",
      curMsgObj: {},
      isShow: false,
      curIndex: 0,
      tip: false
    };
  },

  watch: {
    valueObj: {
      deep: true,
      handler: function(newV, oldV) {
        this.label = this.valueObj.label;
        this.curMsgObj = this.valueObj;
      }
    }
  },
  created() {
    // if (this.valueObj.label) {
    //   this.label = this.valueObj.label;
    // }
    this.$on("curOptVal", this.curOptVal);
  },

  mounted() {
    document.addEventListener("click", e => {
      if (this.isShow) {
        var sp = document.getElementById(this.id);
        if (sp && !sp.contains(e.target)) {
          this.isShow = false;
        }
      }
    });
  },
  methods: {
    updateScroll() {
      this.$refs.scrollbar.update();
    },
    blurInput() {
      if (this.label !== this.curMsgObj.label) {
        if (!this.easy) {
          this.label = "";
          this.$emit("callEvent", {});
          this.tip = true;
        } else {
          this.$emit("callEvent", { label: this.label });
        }
      }
    },
    // blurInput() {
    //   this.$emit("blur", this.label);
    //   // 判断加上 undefined的情况
    //   if (this.label !== this.curMsgObj.label || !this.label) {
    //     this.label = "";
    //     this.tip = true;
    //     // 响应v-model 事件
    //     this.$emit("callEvent", {});
    //   }
    // },
    focusInput() {
      this.isShow = this.triggerOnFocus ? true : false;
      this.tip = false;
      this.$emit("focus");
    },
    // focusInput() {
    //   this.$emit("focus", this.label);
    //   this.isShow = true;
    //   this.tip = false;
    // },
    curOptVal(val) {
      this.tip = false;
      this.curMsgObj = val;
      this.label = val.label;
      this.$emit("callEvent", this.curMsgObj);
      this.$emit("changeOpt", this.curMsgObj);
      this.isShow = false;
    },
    changeWord() {
      if (this.isInput) {
        console.log("🚀 ~ this.label", this.label);

        this.$emit("callEvent", { label: this.label });
      } else {
        this.$emit("filterOpt", this.label);
      }

      if (!this.triggerOnFocus) {
        this.isShow = this.label.length > 0 ? true : false;
      }
    },
    // changeWord() {
    //   // 输入事件
    //   this.$emit("filterOpt", this.label);
    // },
    clearVal() {
      this.label = "";
      this.$emit("callEvent", {});
    },
    tipsShow() {
      if (this.label) {
        this.tip = false;
      } else {
        this.tip = true;
      }
    }
  }
};
</script>
<style>
/* .el-scrollbar__wrap {
  overflow: hidden;
} */
</style>
<style scoped>
.clearInput {
  background: none;
  outline: none;
  border: 1px solid #dcdfe6;
  height: 28px;
  padding: 0 5px !important;
  border-radius: 4px;
  font-size: 12px;
  width: 170px;
}
.clearInput:focus {
  border-radius: 4px;
  border: 1px solid #dcdfe6;
}
.s-label {
  height: 30px;
  line-height: 30px;
  font-size: 13px;
}
.s-loading {
  width: 20px;
  margin: 10px auto;
}
.s-warp {
  display: inline-block;
  vertical-align: top;
  position: relative;
  font-size: 13px;
}
.s-header {
  font-weight: 700;
  padding-left: 6px;
  background: #f0f0f0;
  line-height: 30px;
  font-size: 13px;
}
.s-ulBox {
  max-height: 300px;
  width: 180px;
  padding: 10px 0;
}
.s-show {
  position: absolute;
  overflow-x: hidden;
  background: #fff;
  border: 1px solid #eee;
  border-radius: 5px;
  right: 0px;
  z-index: 66;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.is-active {
  background: #f5f7fa;
}
.NoData {
  color: #555;
  width: 170px;
  text-align: center;
  line-height: 30px;
  font-size: 12px;
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/userCenter/statement/select/bySelect.vue